<template>
    <v-dialog
            v-model="contactDialog"
            width="500"
    >
        <template v-slot:activator="{ on }">
            <v-btn
                    color="primary"
                    fab
                    absolute
                    top
                    right
                    dark
                    v-on="on"
                    :disabled="disabled"
                    class="mt-5"
            >
                <v-icon>contact_support</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title
                    primary-title
            >

                <div class="headline" style="width:100%">{{__('dialogs.contact_title')}}</div>
                <div class="subheading" style="width:100%">{{__('dialogs.contact_text')}}</div>
            </v-card-title>

            <v-card-text>

                <v-list two-line>
                    <v-list-tile :href="'mailto:'+company.email" target="_blank">
                        <v-list-tile-action>
                            <v-icon color="primary">mail</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                            <v-list-tile-title>{{company.email}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{__('dialogs.contact_send_email')}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="primary"
                        flat
                        @click="contactDialog = false;"
                >
                  {{__('dialogs.close')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "ContactDialog",
        props:{
            disabled:Boolean,
            company: Object
        },
        data: function () {
            return {
                contactDialog: false,
            }
        },
    }
</script>

<style scoped>

</style>
